import react, { Fragment, useEffect, useState } from "react";
import { Combobox } from "@headlessui/react";
import GetHoodList from "../../services/getHoodsList";


export default function NewImvSearch() {

    const [selectedHood, setSelectedHood] = useState('Americanopolis')
    const [query, setQuery] = useState('')
    const [hoodList, setHoodList] = useState(undefined)

    useEffect(() => {
        const getHoods = () => {
            setHoodList(GetHoodList)
        }

        getHoods()

    }, [])

    return (<>
        <article className="text-black bg-[#1d4aa7]">
            {/* <Combobox value={selectedHood} onChange={setSelectedHood}>
                <Combobox.Input 
                    className='p-10 w-full'
                    onChange={(event) => setQuery(event.target.value)} />
                    
                <Combobox.Options>
                    {hoodList.map((hood) => (
                        <Combobox.Option key={hood} value={hood} as={Fragment}>
                            {({ active, selected }) => (
                                <li className={`${active ? 'bg-blue-500 text-white' : 'bg-slate-700 text-white'}`}>
                                    {selected &&
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>
                                    }
                                    {hood}
                                </li>
                            )}
                        </Combobox.Option>
                    ))}
                </Combobox.Options>
            </Combobox> */}
        </article>
    </>)
}